import {Button, message, Space, Tooltip} from "antd";
import {
  CopyIcon,
  CopyIconSm,
  FacebookIconSm,
  MailIcon,
  XIcon,
} from "../../../icons/icons";
import {FacebookFilled, MailFilled, TwitterOutlined} from "@ant-design/icons";
import {useState} from "react";

type TShareOfferingWidgetProps = {
  extraParams: {
    facebookLink: string;
    twitterLink: string;
    mailLink: string;
    copyLink: string;
  };
  title: string;
};

export function ShareOfferingWidget({extraParams, title}: TShareOfferingWidgetProps) {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <div>
      <Space
        direction="vertical"
        size={17}
        style={{
          display: "flex",
        }}
      >
        <p
          style={{
            color: "#000709",
            fontWeight: "600",
          }}
        >
          {title}
        </p>
        <div>
          <Space direction="horizontal" size={12}>
            <div
              style={{
                color: "#9254DE",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                href="#!"
                title="Copy url"
                onClick={() =>
                  navigator.clipboard
                    .writeText(extraParams.copyLink)
                    .then(() => message.success("Copied!"))
                }
              >
                <CopyIconSm style={{fontSize: "2rem"}} />
              </a>
            </div>
            <div
              style={{
                color: "#3B5998",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                target="_blank"
                rel="noreferrer"
                href={`${extraParams.facebookLink}`}
                title="Share on Facebook"
              >
                <FacebookIconSm style={{fontSize: "2rem"}} />
              </a>
            </div>
            <div
              style={{
                border: "none",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a
                target="_blank"
                rel="noreferrer"
                href={`${extraParams.twitterLink}`}
                title="Share on X"
              >
                <XIcon style={{fontSize: "2rem"}} />
              </a>
            </div>
            <div
              style={{
                border: "none",
                height: "3rem",
                width: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a href={`${extraParams.mailLink}`} title="Share through Email">
                <MailIcon style={{fontSize: "2rem"}} />
              </a>
            </div>
          </Space>
        </div>
      </Space>
    </div>
  );
}
